import React from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';

import { Form, DatePicker } from 'ui/components';
import { formatDate, isValidDate } from 'utilities/common';
import { UTCFormat } from 'utilities/common';

const initialState = {
    date: {
        default: new Date(),
        formatted: formatDate(new Date(), 'YYYY-MM-DD'),
    },
    time: '',
    localeTimeZome: new Date().toLocaleDateString('id-ID', { day: '2-digit', timeZoneName: 'short' }).slice(3),
};

export const ActionDate = ({
    disabled,
    onSubmit,
    initialDate,
    dateLabel,
    timeLabel,
    errors,
    handleClose
}) => {
    const StateForm = useSelector((state) => state?.Form);

    const [{ date, time }, setState] =
        React.useState(initialState);

    const $handleSubmit = async () => {
        const payload = {
            time: UTCFormat(date?.formatted, time),
        };

        onSubmit(payload);
    };

    React.useEffect(() => {
        if (!initialDate) return;

        setState((prevState) => ({
            ...prevState,
            date: {
                default: isValidDate(initialDate) ? new Date(initialDate) : new Date(),
                formatted: formatDate(
                    isValidDate(initialDate) ? initialDate : new Date(),
                    'YYYY-MM-DD'
                ),
            },
            time: isValidDate(initialDate) ? formatDate(initialDate, 'HH:mm') : '',
        }));
    }, [initialDate]);

    React.useEffect(() => {
        if (initialDate) return;

        setState((prevState) => ({
            ...prevState,
            date: {
                default: new Date(),
                formatted: formatDate(new Date(), 'YYYY-MM-DD'),
            },
            time: '',
        }));
    }, [initialDate]);

    return (
        <div>
            <div className="p-3 py-2">
                <div className="row">
                    <div className="col-7">
                        <label className="form-label required fs-8">{dateLabel}</label>
                        <div className={errors ? 'border border-danger rounded' : ''}>
                            <DatePicker
                                type="normal"
                                value={date?.default || null}
                                format="dd/MM/yyyy"
                                onChange={(date) => {
                                    setState((prevState) => ({
                                        ...prevState,
                                        date: {
                                            default: date,
                                            formatted: formatDate(date, 'YYYY-MM-DD'),
                                        },
                                    }));
                                }}
                                isShowTrigger
                                error={errors}
                            />
                        </div>
                        {errors && (
                            <div className="invalid-feedback p-0 d-block">
                                {errors}
                            </div>
                        )}
                    </div>
                    <div className="col-5">
                        <Form.Time
                            required={disabled ? false : true}
                            label={timeLabel}
                            value={time}
                            onChange={(e) =>
                                setState((prevState) => ({
                                    ...prevState,
                                    time: e,
                                }))
                            }
                            error={errors}
                            disabled={disabled}
                        />
                    </div>

                </div>
            </div>
            <div className="card-footer-gray  border-top p-3">
                <button className="btn btn-sm btn-default me-2" style={{ width: 100 }} onClick={handleClose}>Batal</button>
                <button className={cn('btn btn-sm btn-success', StateForm?.loading ? 'btn-loading' : '')} style={{ width: 100 }} onClick={$handleSubmit}>Simpan</button>
            </div>
        </div>
    );
};
